import { UncontrolledModal } from "./UncontrolledModal"
import { UncontrolledModalClose } from "./UncontrolledModalClose"
import { UncontrolledModalCancel } from "./UncontrolledModalCancel"

UncontrolledModal.Close = UncontrolledModalClose

UncontrolledModal.Cancel = UncontrolledModalCancel

export default UncontrolledModal
